export default __webpack_public_path__ + "static/media/Group 90.db074a89.svg";